import React, { FC } from 'react';
import DangerouslySetInnerHtml from 'components/DangerouslySetInnerHtml';

import classnames from 'classnames';
import { ContactInfoProps } from './models';
import './ContactInfo.scss';

const ContactInfo: FC<ContactInfoProps> = ({
  className,
  otherCommuniactionMethodsDescriptionText,
  brandPhoneLabel,
  brandPhoneText,
  brandPhone,
  brandMailText,
  brandEmailLabel,
  brandEmailText,
  brandMailLabel,
}) => (
  <div className={classnames('contact-info', className)}>
    {otherCommuniactionMethodsDescriptionText ? (
      <p className="contact-info__paragraph contact-info__methods-description">
        <DangerouslySetInnerHtml
          className="contact-info__paragraph"
          html={otherCommuniactionMethodsDescriptionText}
        />
      </p>
    ) : null}

    {brandPhoneLabel || brandPhoneText ? (
      <div className="contact-info__section">
        <span className="contact-info__label">{brandPhoneLabel}</span>
        <p className="contact-info__paragraph">
          <DangerouslySetInnerHtml html={brandPhoneText} />
          <DangerouslySetInnerHtml
            className="contact-info__paragraph--highlighted"
            html={brandPhone}
          />
        </p>
      </div>
    ) : null}

    {brandMailLabel || brandMailText ? (
      <div className="contact-info__section">
        <span className="contact-info__label">{brandMailLabel}</span>
        <p>
          <DangerouslySetInnerHtml className="contact-info__paragraph" html={brandMailText} />
        </p>
      </div>
    ) : null}

    {brandEmailLabel || brandEmailText ? (
      <div className="contact-info__section">
        <span className="contact-info__label">{brandEmailLabel}</span>
        <p>
          <DangerouslySetInnerHtml
            className="contact-info__paragraph contact-info__paragraph--bold"
            html={brandEmailText}
          />
        </p>
      </div>
    ) : null}
  </div>
);

export default ContactInfo;
